import React from "react";
import { createBrowserHistory } from "history";
import { Router } from "react-router";
import { Route, Switch } from "react-router-dom";

//theme
import Menu from "./components/theme/Menu";
import TopBar from "./components/theme/TopBar";
import SideMenu from "./components/theme/SideMenu";
import Footer from "./components/theme/Footer";

//pages and middleware
import Login from "./components/pages/login/Home";
import LoginCorretora from "./components/pages/login/LoginCorretora";

//route protection
import PrivateRoute from "./components/routes/PrivateRoute";
import Forbidden from "./components/pages/errors/Forbidden";

//manager
import Dashboard from "./components/pages/dashboard/Index";

//user
import UserIndex from "./components/pages/usuarios/Index";
import Perfil from "./components/pages/usuarios/Perfil";

//modelos de email
import IndexEmailModelos from "./components/pages/emails-modelos/IndexEmailModelos";
import CreateEmailModelos from "./components/pages/emails-modelos/CreateEmailModelos";
import EditEmailModelos from "./components/pages/emails-modelos/EditEmailModelos";

//Campanhas
import IndexCampanhas from "./components/pages/campanhas/IndexCampanhas";
import CreateCampanhas from "./components/pages/campanhas/CreateCampanhas";
import EditCampanhas from "./components/pages/campanhas/EditCampanhas";

import ReportEmails from "./components/pages/relatorio-email";

//Notificações
import IndexNotificacoes from "./components/pages/notificacoes/IndexNotificacoes";
import CreateNotificacoes from "./components/pages/notificacoes/CreateNotificacoes";
import EditNotificacoes from "./components/pages/notificacoes/EditNotificacoes";

//disparos de emails
import IndexEnvioEmails from "./components/pages/envio-emails/IndexEnvioEmails";
import CreateEnvioEmails from "./components/pages/envio-emails/CreateEnvioEmails";
import VisualizarEnvioEmails from "./components/pages/envio-emails/VisualizarEnvioEmails";
import ConsultarBlackList from "./components/pages/envio-emails/ConsultarBlackList";

//Filas de E-mais
import IndexFilasEmails from "./components/pages/filas-emails/IndexFilasEmails";
import IndexFilasNotificacoes from "./components/pages/filas-notificacoes/indexFilasNotificacoes";

//Relatorios Vida Em Grupo
import TrabalhadorVidaEmGrupo from "./components/pages/vidaemgrupo/ExcelTrabalhador";
import PagamentoSegProprio from "./components/pages/vidaemgrupo/PagamentoSegProprio";
import PagamentoSegSindical from "./components/pages/vidaemgrupo/PagamentoSegSindical";
import TrabalhadorSegProprio from "./components/pages/vidaemgrupo/TrabalhadorSegProprio";
import TrabalhadorSegSindical from "./components/pages/vidaemgrupo/TrabalhadorSegSindical";

//Relatorios NetPoints
import NetPointsPagamentos from "./components/pages/netpoints/NetPointsPagamentos";
import NetPointsEmpresas from "./components/pages/netpoints/NetPointsEmpresas";
import ExcelNetPointsPagamentos from "./components/pages/netpoints/ExcelNetPointsPagamentos";

//Relatorio Internos
import DiferencasPagamentos from "./components/pages/resumos/ExcelDiferencasPagamentos";
import ResumoPagamentos from "./components/pages/resumos/ResumoPagamentos";
import ResumoEventos from "./components/pages/resumos/ResumoEventos";
import ResumoImpressoes from "./components/pages/resumos/ResumoImpressoes";
import ResumoImpressoesAnalitico from "./components/pages/resumos/ResumoImpressoesAnalitico";
import ResumoImpressoesPorVencimentos from "./components/pages/resumos/ResumoImpressoesPorVencimento";
import PagamentosRetornos from "./components/pages/resumos/PagamentosRetornos";
import PagamentosVencimentos from "./components/pages/resumos/PagamentosVencimentos";
import PagamentosContas from "./components/pages/resumos/PagamentosContas";
import PagamentosDuplicados from "./components/pages/relatorios_internos/PagamentosDuplicados";
import CancelarBoletosPagos from "./components/pages/relatorios_internos/CancelarBoletosPagos";
import CobrancaBSF from "./components/pages/relatorios_internos/CobrancaBSF";
import EstornoBanco from "./components/pages/relatorios_internos/EstornoBanco";
import UltimoRecxPagto from "./components/pages/relatorios_internos/UltimoRecxPagto";
import AgendaVencimento from "./components/pages/relatorios_internos/AgendaVencimento";

//Analise Inadimplentes
import InadimplentesComImpressao from "./components/pages/inadimplentes/InadimplentesComImp";
import InadimplentesSemImpressao from "./components/pages/inadimplentes/InadimplentesSemImp";
import ControleComplemento from "./components/pages/inadimplentes/ControleComplemento";

//Relatorios Trabalhadores
import TrabalhadorEmpresa from "./components/pages/trabalhadores/TrabalhadorrEmpresa";
import ExcelTrabalhadorPagamento from "./components/pages/trabalhadores/ExcelTrabalhadorPagamento";
import TrabalhadorPagamento from "./components/pages/trabalhadores/TrabalhadorrPagamento";
import TrabalhadorEmpresaSemDireito from "./components/pages/trabalhadores/TrabalhadorrEmpresaSemDireito";
import TrabalhadorAlterar from "./components/pages/trabalhadores/TrabalhadorrAlterar";
import TrabalhadorIncluir from "./components/pages/trabalhadores/TrabalhadorrIncluir";

//Relatorios Empresas
import Pagamentos from "./components/pages/relatorios_internos/Pagamentos";
import Impressoes from "./components/pages/relatorios_internos/Impressoes";
import ImpressoesPorVencto from "./components/pages/relatorios_internos/ImpressoesPorVencto";
import Emails from "./components/pages/relatorios_internos/Emails";
import Operadores from "./components/pages/relatorios_internos/Operadores";
import ListaEmpresa from "./components/pages/empresas/ListaEmpresa";
import ConsultaEmpresa from "./components/pages/empresas/ConsultaEmpresa";
import TipoCobranca from "./components/pages/empresas/EmpresaTipoCobranca";
import EmpresaBoletos from "./components/pages/empresas/EmpresaBoletos";
import EmpresaPlanos from "./components/pages/empresas/EmpresaPlanos";
import PlanoEmpresas from "./components/pages/empresas/PlanoEmpresas";
import LogEmpresa from "./components/pages/empresas/LogEmpresa";
import EmpresaTrabalhadorPlanilha from "./components/pages/empresas/EmpresaTrabalhadorPlanilha";
import EmpresaTrabalhadorUpload from "./components/pages/empresas/EmpresaTrabalhadorUpload";
import ConsultaReceita from "./components/pages/relatorios_internos/ConsultaReceita";
import ConsultaReceitaCNPJ from "./components/pages/relatorios_internos/ConsultaReceitaCNPJ";

//Relatorios Empresas Personal
import EmpresasMigradas from "./components/pages/empresas/EmpresasMigradas";
import EmpresasMigradasPlano from "./components/pages/empresas/EmpresasMigradasPlano";
import EmpresasMigradasPlanoPagamentos from "./components/pages/empresas/EmpresasMigradasPlanoPagamentos";
import EmpresasMigradasPlanoInadimp from "./components/pages/empresas/EmpresasMigradasPlanoInadimp";
import EmpresasPersonal from "./components/pages/empresas/EmpresasPersonal";
import ImpressoesPersonal from "./components/pages/empresas/ImpressoesPersonal";

//Relatorios PAS
import PagamentosPAS from "./components/pages/PAS/PagamentosPAS";
import ImpressoesPAS from "./components/pages/PAS/ImpressoesPAS";
import TrabalhadorPAS from "./components/pages/PAS/ExcelTrabalhadorPAS";
import BoletosPAS from "./components/pages/PAS/EmpresaBoletosPAS";
import ComparativoPAS from "./components/pages/PAS/ComparativoPAS";
import ComparativoTrabalhadorPAS from "./components/pages/PAS/ComparativoTrabalhadorPAS";

//Relatorios PRAGAS
import PagamentosPRAGAS from "./components/pages/PRAGAS/PagamentosPRAGAS";
import ImpressoesPRAGAS from "./components/pages/PRAGAS/ImpressoesPRAGAS";
import BoletosPRAGAS from "./components/pages/PRAGAS/EmpresaBoletosPRAGAS";
import ComparativoPRAGAS from "./components/pages/PRAGAS/ComparativoPRAGAS";

//Relatorios SINSAGE
import PagamentosSINSAGE from "./components/pages/SINSAGE/PagamentosSINSAGE";
import ImpressoesSINSAGE from "./components/pages/SINSAGE/ImpressoesSINSAGE";
import BoletosSINSAGE from "./components/pages/SINSAGE/EmpresaBoletosSINSAGE";
import ComparativoSINSAGE from "./components/pages/SINSAGE/ComparativoSINSAGE";

//Relatorios SINBERF
import PagamentosSINBERF from "./components/pages/SINBERF/PagamentosSINBERF";
import ImpressoesSINBERF from "./components/pages/SINBERF/ImpressoesSINBERF";
import BoletosSINBERF from "./components/pages/SINBERF/EmpresaBoletosSINBERF";
import ComparativoSINBERF from "./components/pages/SINBERF/ComparativoSINBERF";

//Relatorios APOIAR
import PagamentosAPOIAR from "./components/pages/APOIAR/PagamentosAPOIAR";
import ImpressoesAPOIAR from "./components/pages/APOIAR/ImpressoesAPOIAR";
import BoletosAPOIAR from "./components/pages/APOIAR/EmpresaBoletosAPOIAR";
import TrabalhadoresAPOIAR from "./components/pages/APOIAR/TrabalhadorrEmpresaAPOIAR";
import OperadoresAPOIAR from "./components/pages/APOIAR/OperadoresAPOIAR";

//Relatorio de Trabalhadores - PRESTADORES
import Trabalhadores_CMD from "./components/pages/CMD/TrabalhadorPagamento_CMD";
import TrabalhadoresDemitidos_CMD from "./components/pages/CMD/TrabalhadorDemitido_CMD";
import Trabalhadores_FAIRFAX from "./components/pages/FAIRFAX/TrabalhadorPagamento_FAIRFAX";
import TrabalhadoresDemitidos_FAIRFAX from "./components/pages/FAIRFAX/TrabalhadorDemitido_FAIRFAX";

//Relatorios Entidades
import AcessoNetEntidade from "./components/pages/entidades/AcessoNetEntidade";
import PlanosEntidade from "./components/pages/entidades/PlanosEntidade";
import AdicionaisIndex from "./components/pages/relatorios-entidade/adicionais/index";
import ListagemSeguradora from "./components/pages/relatorios-entidade/seguradoras/ListagemSeguradora";
import TrabalhadorPrestadoresIndex from "./components/pages/relatorios-entidade/trabalhadores/index";
import TrabalhadorPrestadoresOldIndex from "./components/pages/relatorios-entidade/trabalhadores/index_old";
import TrabalhadoresTotaisIndex from "./components/pages/relatorios-entidade/trabalhadores-totais/index";

//Relatorios Planos
import Analise1Plano from "./components/pages/planos/Analise1Plano";
import Analise2Plano from "./components/pages/planos/Analise2Plano";
import Analise3Plano from "./components/pages/planos/Analise3Plano";
import ResyncBoletos from "./components/pages/relatorios_internos/ResyncBoletos";

//Conecta
import TrabalhadorConecta from "./components/pages/conecta/TrabalhadorConecta";
import SmsPushConecta from "./components/pages/conecta/SmsPushConecta";

//Sorteio
import TrabalhadorSorteio from "./components/pages/sorteio/TrabalhadorSorteio";
import TrabalhadorGanhador from "./components/pages/sorteio/TrabalhadorGanhador";
import Ganhadores from "./components/pages/sorteio/Ganhadores";

//Ponto Remoto
import EmpresasPontoRemotoMADIS from "./components/pages/MADIS/EmpresasPontoRemoto";
import EmpresasPontoRemotoMyWork from "./components/pages/MyWork/EmpresasPontoRemoto";

//Comparativo Postos

import ComparativoPostos from "./components/pages/relatorios_internos/ComparativoPostos";

//Contador
import ContadorEmpresa from "./components/pages/contador/ContadorEmpresa";
import Contador from "./components/pages/contador/Contador";
import ContadorOperador from "./components/pages/contador/ContadorOperador";

//SERASA
import SerasaEmpresas from "./components/pages/SERASA/Empresas";

//GATEWAY
import TransacoesEmpresas from "./components/pages/Gateway/EmpresaTransacoes";

//DEPENDENTE
import PagamentoOdontologico from "./components/pages/odontologico/PagamentoOdontologico";

//SMS
//VIDALINK
import CartoesVidalink from "./components/pages/SMS/CartoesVidalink";
import CartoesNaoValidados from "./components/pages/SMS/CartoesNaoValidados";
import CartoesValidade from "./components/pages/SMS/CartoesValidade";
import CartoesFuncional from "./components/pages/SMS/CartoesFuncional";
import PlanoInativado from "./components/pages/SMS/PlanoInativado";
import SmsEmpresasCnpj from "./components/pages/SMS/SmsEmpresasCnpj";

import EmailConfig from "./components/pages/email-config";
import PagamentoAdicional from "./components/pages/adicional/Pagamentos";
import TrabalhadorPagamento_CMD from "./components/pages/CMD/TrabalhadorPagamento_CMD";
import TrabalhadorDemitido_CMD from "./components/pages/CMD/TrabalhadorDemitido_CMD";
import TrabalhadorPagamento_FAIRFAX from "./components/pages/FAIRFAX/TrabalhadorPagamento_FAIRFAX";
import TrabalhadorDemitido_FAIRFAX from "./components/pages/FAIRFAX/TrabalhadorDemitido_FAIRFAX";

let history = createBrowserHistory();

class Routes extends React.Component {
    render() {
        return (
            <div className="scope-route">
                <TopBar />
                <Menu />
                <SideMenu />
                <Router history={history}>
                    <Switch>
                        {/*LOGIN*/}
                        <Route exact path="/" component={LoginCorretora} />
                        <Route exact path="/login" component={Login} />

                        {/*ERROR PAGES*/}
                        <Route
                            exact
                            path="/manager/403"
                            component={Forbidden}
                        />

                        {/*PRIVATE ROUTES*/}
                        {/*BASE E USUARIOS*/}
                        <PrivateRoute
                            exact
                            path="/manager/dashboard"
                            component={Dashboard}
                            skipPermissionCheck={true}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/usuarios"
                            component={UserIndex}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/perfil"
                            component={Perfil}
                            skipPermissionCheck={true}
                        />

                        {/*RELATORIOS VIDA EM GRUPO*/}
                        <PrivateRoute
                            exact
                            path="/manager/vidaemgrupo/trabalhador"
                            component={TrabalhadorVidaEmGrupo}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/vidaemgrupo/pagamentosegproprio"
                            component={PagamentoSegProprio}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/vidaemgrupo/pagamentosegsindical"
                            component={PagamentoSegSindical}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/vidaemgrupo/trabalhadorsegproprio"
                            component={TrabalhadorSegProprio}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/vidaemgrupo/trabalhadorsegsindical"
                            component={TrabalhadorSegSindical}
                        />

                        {/*RELATORIOS NETPOINTS*/}
                        <PrivateRoute
                            exact
                            path="/manager/netpoints/pagamentos"
                            component={NetPointsPagamentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/netpoints/empresas"
                            component={NetPointsEmpresas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/netpoints/excelpagamentos"
                            component={ExcelNetPointsPagamentos}
                        />

                        {/*RELATORIOS INTERNOS*/}
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/diferencas"
                            component={DiferencasPagamentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/resumopagamentos"
                            component={ResumoPagamentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/resumoimpressoes"
                            component={ResumoImpressoes}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/resumoimpressoesanalitico"
                            component={ResumoImpressoesAnalitico}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/resumoimpressoesvencimentos"
                            component={ResumoImpressoesPorVencimentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/pagamentoscontas"
                            component={PagamentosContas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/pagamentosretornos"
                            component={PagamentosRetornos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/pagamentosvencimentos"
                            component={PagamentosVencimentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/pagamentosduplicados"
                            component={PagamentosDuplicados}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/cancelarboletospagos"
                            component={CancelarBoletosPagos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/cobrancabsf"
                            component={CobrancaBSF}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/resyncboletos"
                            component={ResyncBoletos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/estornobanco"
                            component={EstornoBanco}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/ultimorecxpagto"
                            component={UltimoRecxPagto}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/webben"
                            component={ResumoEventos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/postos"
                            component={ComparativoPostos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/agenda-vencimento"
                            component={AgendaVencimento}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/consultareceita"
                            component={ConsultaReceita}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/consultareceitaCNPJ"
                            component={ConsultaReceitaCNPJ}
                        />

                        {/*EMPRESAS*/}
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/pagamentos"
                            component={Pagamentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/impressoes"
                            component={Impressoes}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/impressoesporvencto"
                            component={ImpressoesPorVencto}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/inadimplentescomimp"
                            component={InadimplentesComImpressao}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/inadimplentessemimp"
                            component={InadimplentesSemImpressao}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/controlecomplemento"
                            component={ControleComplemento}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/emails"
                            component={Emails}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/ses"
                            component={ReportEmails}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/operadores"
                            component={Operadores}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios/tipocobranca"
                            component={TipoCobranca}
                        />

                        {/*RELATORIOS TRABALHADORES*/}
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/trabalhadorempresa"
                            component={TrabalhadorEmpresa}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/trabalhadorpagamento"
                            component={TrabalhadorPagamento}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/exceltrabalhadorpagamento"
                            component={ExcelTrabalhadorPagamento}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/trabalhadorempresasemdireito"
                            component={TrabalhadorEmpresaSemDireito}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/trabalhadoralterar"
                            component={TrabalhadorAlterar}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/trabalhadores/trabalhadorincluir"
                            component={TrabalhadorIncluir}
                        />

                        {/*PAS*/}
                        <PrivateRoute
                            exact
                            path="/manager/PAS/pagamentosPAS"
                            component={PagamentosPAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PAS/impressoesPAS"
                            component={ImpressoesPAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PAS/trabalhadorPAS"
                            component={TrabalhadorPAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PAS/boletosPAS"
                            component={BoletosPAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PAS/comparativo"
                            component={ComparativoPAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PAS/comparativo/trabalhador"
                            component={ComparativoTrabalhadorPAS}
                        />

                        {/*PRAGAS*/}
                        <PrivateRoute
                            exact
                            path="/manager/PRAGAS/pagamentosPRAGAS"
                            component={PagamentosPRAGAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PRAGAS/impressoesPRAGAS"
                            component={ImpressoesPRAGAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PRAGAS/boletosPRAGAS"
                            component={BoletosPRAGAS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/PRAGAS/comparativo"
                            component={ComparativoPRAGAS}
                        />

                        {/*SINSAGE*/}
                        <PrivateRoute
                            exact
                            path="/manager/SINSAGE/pagamentosSINSAGE"
                            component={PagamentosSINSAGE}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINSAGE/impressoesSINSAGE"
                            component={ImpressoesSINSAGE}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINSAGE/boletosSINSAGE"
                            component={BoletosSINSAGE}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINSAGE/comparativo"
                            component={ComparativoSINSAGE}
                        />

                        {/*SINBERF*/}
                        <PrivateRoute
                            exact
                            path="/manager/SINBERF/pagamentosSINBERF"
                            component={PagamentosSINBERF}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINBERF/impressoesSINBERF"
                            component={ImpressoesSINBERF}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINBERF/boletosSINBERF"
                            component={BoletosSINBERF}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/SINBERF/comparativo"
                            component={ComparativoSINBERF}
                        />

                        {/*APOIAR*/}
                        <PrivateRoute
                            exact
                            path="/manager/APOIAR/pagamentosAPOIAR"
                            component={PagamentosAPOIAR}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/APOIAR/impressoesAPOIAR"
                            component={ImpressoesAPOIAR}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/APOIAR/boletosAPOIAR"
                            component={BoletosAPOIAR}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/APOIAR/trabalhadoresAPOIAR"
                            component={TrabalhadoresAPOIAR}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/APOIAR/operadoresAPOIAR"
                            component={OperadoresAPOIAR}
                        />

                        {/*RELATORIOS EMPRESAS*/}
                        <PrivateRoute
                            exact
                            path="/manager/empresas/listaempresa"
                            component={ListaEmpresa}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/consultaempresa"
                            component={ConsultaEmpresa}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresaboletos"
                            component={EmpresaBoletos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresaplanos"
                            component={EmpresaPlanos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/planoempresas"
                            component={PlanoEmpresas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/logempresa"
                            component={LogEmpresa}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresatrabalhadorplanilha"
                            component={EmpresaTrabalhadorPlanilha}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresatrabalhadorupload"
                            component={EmpresaTrabalhadorUpload}
                        />

                        {/*RELATORIOS EMPRESAS PERSONAL*/}
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresasmigradas"
                            component={EmpresasMigradas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresasmigradasplano"
                            component={EmpresasMigradasPlano}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresasmigradasplanopagamentos"
                            component={EmpresasMigradasPlanoPagamentos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresasmigradasplanoinadimp"
                            component={EmpresasMigradasPlanoInadimp}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/empresaspersonal"
                            component={EmpresasPersonal}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/empresas/impressoespersonal"
                            component={ImpressoesPersonal}
                        />

                        {/*RELATORIOS TRABALHADORES - PRESTADORES*/}
                        <PrivateRoute
                            exact
                            path="/manager/assistencia/cobranca"
                            component={PagamentoAdicional}
                        />

                        {/*RELATORIOS TRABALHADORES - PRESTADORES*/}

                        <PrivateRoute
                            exact
                            path="/manager/prestadores/Favorecido/trabalhadores"
                            component={TrabalhadorPagamento_CMD}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/prestadores/Favorecido/trabalhadoresdemitidos"
                            component={TrabalhadorDemitido_CMD}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/prestadores/CMD/trabalhadores"
                            component={TrabalhadorPagamento_CMD}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/prestadores/CMD/trabalhadoresdemitidos"
                            component={TrabalhadorDemitido_CMD}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/prestadores/FAIRFAX/trabalhadores"
                            component={TrabalhadorPagamento_FAIRFAX}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/prestadores/FAIRFAX/trabalhadoresdemitidos"
                            component={TrabalhadorDemitido_FAIRFAX}
                        />

                        {/*RELATORIOS ENTIDADES*/}
                        <PrivateRoute
                            exact
                            path="/manager/entidades/acessonet"
                            component={AcessoNetEntidade}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/entidades/planos"
                            component={PlanosEntidade}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios-entidade/adicionais"
                            component={AdicionaisIndex}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios-entidade/seguradoras"
                            component={ListagemSeguradora}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios-entidade/trabalhadores"
                            component={TrabalhadorPrestadoresIndex}
                        />
                        <Route
                            exact
                            path="/manager/relatorios-entidade/trabalhadores-old"
                            component={TrabalhadorPrestadoresOldIndex}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/relatorios-entidade/trabalhadores-totais"
                            component={TrabalhadoresTotaisIndex}
                        />

                        {/*RELATORIOS PLANOS*/}
                        <PrivateRoute
                            exact
                            path="/manager/planos/analise1"
                            component={Analise1Plano}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/planos/analise2"
                            component={Analise2Plano}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/planos/analise3"
                            component={Analise3Plano}
                        />

                        {/*RELATORIOS CONECTA*/}
                        <PrivateRoute
                            exact
                            path="/manager/conecta/trabalhadorconecta"
                            component={TrabalhadorConecta}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/conecta/smspush"
                            component={SmsPushConecta}
                        />

                        {/*RELATORIOS SORTEIO*/}
                        <PrivateRoute
                            exact
                            path="/manager/sorteio/trabalhadorsorteio"
                            component={TrabalhadorSorteio}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/sorteio/trabalhadorganhador"
                            component={TrabalhadorGanhador}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/sorteio/ganhadores"
                            component={Ganhadores}
                        />

                        {/*SERASA ENTIDADES*/}
                        <PrivateRoute
                            exact
                            path="/manager/serasa/empresas"
                            component={SerasaEmpresas}
                        />

                        {/*GATEWAY*/}
                        <PrivateRoute
                            exact
                            path="/manager/gateway/transacoesempresas"
                            component={TransacoesEmpresas}
                        />

                        {/*SMS*/}
                        {/*VIDALINK*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/cartoesvidalink"
                            component={CartoesVidalink}
                        />
                        {/*Cartao Nao Validados*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/cartoesnaovalidados"
                            component={CartoesNaoValidados}
                        />
                        {/*Cartao x Validade*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/cartoesvalidade"
                            component={CartoesValidade}
                        />
                        {/*Funcional*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/cartoesfuncional"
                            component={CartoesFuncional}
                        />
                        {/*Plano Inativado*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/planoinativado"
                            component={PlanoInativado}
                        />
                        {/*Empresas*/}
                        <PrivateRoute
                            exact
                            path="/manager/sms/smsempresascnpj"
                            component={SmsEmpresasCnpj}
                        />

                        {/*RELATORIOS CONTADOR*/}
                        <PrivateRoute
                            exact
                            path="/manager/contador/contadorempresa"
                            component={ContadorEmpresa}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/contador/contador"
                            component={Contador}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/contador/contadoroperador"
                            component={ContadorOperador}
                        />

                        {/*RELATORIOS PONTO REMOTO*/}
                        <PrivateRoute
                            exact
                            path="/manager/MADIS/empresaspontoremoto"
                            component={EmpresasPontoRemotoMADIS}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/MyWork/empresaspontoremoto"
                            component={EmpresasPontoRemotoMyWork}
                        />

                        {/*MODELOS DE EMAIL*/}
                        <PrivateRoute
                            exact
                            path="/manager/modelos-email"
                            component={IndexEmailModelos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/modelos-email/create"
                            component={CreateEmailModelos}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/modelos-email/edit/:id"
                            component={EditEmailModelos}
                        />

                        {/*CAMPANHAS*/}
                        <PrivateRoute
                            exact
                            path="/manager/campanhas"
                            component={IndexCampanhas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/campanhas/create"
                            component={CreateCampanhas}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/campanhas/edit/:id"
                            component={EditCampanhas}
                        />

                        {/*Notificações*/}
                        <PrivateRoute
                            exact
                            path="/manager/notificacoes"
                            component={IndexNotificacoes}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/notificacoes/create"
                            component={CreateNotificacoes}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/notificacoes/edit/:id"
                            component={EditNotificacoes}
                        />

                        {/*Fila de E-mails*/}
                        <PrivateRoute
                            exact
                            path="/manager/filas-emails"
                            component={IndexFilasEmails}
                        />
                        {/*Fila de Notificações*/}
                        <PrivateRoute
                            exact
                            path="/manager/filas-notificacoes"
                            component={IndexFilasNotificacoes}
                        />

                        {/*ENVIO DE EMAIL*/}
                        <PrivateRoute
                            exact
                            path="/manager/envio-emails"
                            component={IndexEnvioEmails}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/envio-emails/grupo/:uuid"
                            component={VisualizarEnvioEmails}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/envio-emails/create"
                            component={CreateEnvioEmails}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/envio-emails/blacklist"
                            component={ConsultarBlackList}
                        />
                        <PrivateRoute
                            exact
                            path="/manager/email-config"
                            component={EmailConfig}
                        />

                        <PrivateRoute
                            exact
                            path="/manager/odontologico-pagamento"
                            component={PagamentoOdontologico}
                        />
                    </Switch>
                </Router>
                <Footer />
            </div>
        );
    }
}

export default Routes;
